export const theme = {
    primaryBlue: '#1890ff',
    successGreen: '#52c41a',
    warningOrange: '#fa8c16',
    purple: '#722ed1',
    lightBlue: '#1890ff10',
    lightGreen: '#52c41a10',
    lightOrange: '#fa8c1610',
    lightPurple: '#722ed110',
    gray: 'gray',
    red: 'red',
    green: 'green',
    white: '#fff'
  };